<template>
  <div class="aviso-demo tag-periodo-demo">
    Gere seu primeiro diagnóstico e aproveite o período de teste até o dia
    <span style="text-decoration: underline dotted">{{fimDemo}}</span>.
    <br>
    Fique
    tranquilo, após o teste grátis você receberá uma oferta especial
    para continuar o uso desta incrível ferramenta de IA!
    <br>
    <b>Você não será cobrado automaticamente! Use sem moderação!</b>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      fimDemo: moment().add(1, "week").format("DD/MM/YYYY"),
    };
  },
};
</script>

<style scoped>
.aviso-demo {
  box-sizing: border-box;
  margin: 8px auto;
  font-size: 14px;
  width: 100%;
  font-weight: 500;
  text-align: center;
  line-height: 1.5;
  padding: 8px;
  border-radius: 14px;
}

.tag-periodo-demo {
  background-color: #c7ecfa;
  border: 1px solid #72b9d7;
}
</style>